import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import PageTransition from "../components/PageTransition";
import {
  getSubscriptionRequests,
  approveRequest,
  rejectRequest,
} from "../components/DbServices";
import Swal from "sweetalert2";

export default function SubscriptionRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const res = await getSubscriptionRequests();
      if (res.status === 200) {
        setRequests(res.data || []);
      }
      else
      {
        setRequests([]);
      }
    } catch (err) {
      console.error("Error fetching requests:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    const confirm = await Swal.fire({
      title: "Approve this subscription?",
      text: "This will activate the user's new plan.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await approveRequest(id);
      if (res.status === 200) {
        Swal.fire("Approved!", "Plan activated successfully.", "success");
        fetchRequests();
      }
    } catch {
      Swal.fire("Error", "Approval failed", "error");
    }
  };

  const handleReject = async (id) => {
    const confirm = await Swal.fire({
      title: "Reject this subscription?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await rejectRequest(id);
      if (res.status === 200) {
        Swal.fire("Rejected", "Request has been rejected.", "success");
        fetchRequests();
      }
    } catch {
      Swal.fire("Error", "Rejection failed", "error");
    }
  };

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          <div className="mb-4">
            <h3 className="fw-bold">
              <span className="color-theme">Subscription Requests</span>
            </h3>
            <p className="text-muted small">
              Review and approve user subscription upgrade requests.
            </p>
          </div>

          <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead className="border-bottom bg-light">
                  <tr className="small text-uppercase text-muted">
                    <th className="ps-4 py-3">User</th>
                    <th>Plan</th>
                    <th>Requested On</th>
                    <th className="text-center">Status</th>
                    <th className="text-end pe-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="5" className="text-center py-5">
                        <div className="spinner-border text-primary"></div>
                      </td>
                    </tr>
                  ) : requests.length > 0 ? (
                    requests.map((req) => (
                      <tr key={req.id}>
                        <td className="ps-4">
                          <div className="fw-bold small">{req.user_name}</div>
                          <div className="text-muted x-small">{req.email}</div>
                        </td>
                        <td className="small fw-bold">
                          {req.plan_name}
                        </td>
                        <td className="small">
                          {new Date(req.created_at).toLocaleDateString()}
                        </td>
                        <td className="text-center">
                          <span className="badge bg-warning text-dark px-3 py-2 rounded-pill">
                            Pending
                          </span>
                        </td>
                        <td className="text-end pe-4">
                          <button
                            className="btn btn-success btn-sm me-2 rounded-pill px-3"
                            onClick={() => handleApprove(req.id)}
                          >
                            Approve
                          </button>
                          <button
                            className="btn btn-danger btn-sm rounded-pill px-3"
                            onClick={() => handleReject(req.id)}
                          >
                            Reject
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center py-5 text-muted">
                        No pending subscription requests
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}